module.exports = __webpack_public_path__ + "img/ztjz.38ca89e0.png";